import React, { useState, useEffect } from 'react';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import ReactLoading from 'react-loading';
import { validateForm } from '../../selectors/defaultSelectors';
import useFormState from '../FormStateHelper';
import AddressFormFields from '../common/AddressFormFields';
import DevWarning from '../common/DevWarning';

function CheckoutNewAddressForm(props) {
    const {
        formData,
        updateFormData,
        bindUpdateFormData,
        isSubmitting,
        submitForm,
    } = useFormState({
        handleFormSubmission: props.handleFormSubmission,
        initialFormState: {
            Country: window.localeCountry,
        },
    });
    const [isValidated, setIsValidated] = useState(false);
    let fieldRefs = {};

    const handleFormUpdate = (e) => {
        bindUpdateFormData(e);
    };

    const onFormSubmit = (e) => {
        e.preventDefault();

        submitForm(formData, {});
    };

    useEffect(() => {
        if (Object.keys(fieldRefs).length > 0) {
            setIsValidated(!validateForm(fieldRefs));
        }
    }, [formData]);

    return (
        <React.Fragment>
            <form className='form' action='post' onSubmit={onFormSubmit}>
                <DevWarning>
                    <p><LocalizedMessage id={'FIELD.PLEASE_CONFIRM_DOING'} /></p>
                </DevWarning>
                <div className='text-box text-box--xsmall text-box--grey'>
                    <p>
                        <LocalizedMessage id={'CHECKOUT.NEW_ADDRESS.MESSAGE'} />
                    </p>
                </div>
                <AddressFormFields
                    fieldRefs={fieldRefs}
                    formData={formData}
                    updateField={updateFormData}
                    onFieldUpdate={handleFormUpdate}
                    showPhoneField={true}
                />
                <div className='tx-right'>
                    <button
                        type='submit'
                        className={`form__submit button ${!isValidated ? 'button--disabled' : ''
                            }`}
                        disabled={!isValidated}
                    >
                        <span
                            style={{ opacity: isSubmitting === true ? 0 : 1 }}
                        >
                            <LocalizedMessage id={'SAVE'} />
                        </span>
                        {isSubmitting === true && (
                            <ReactLoading
                                className='button__spinner'
                                type='spin'
                                color='white'
                                height={20}
                                width={20}
                            />
                        )}
                    </button>
                </div>
            </form>
        </React.Fragment>
    );
}

export default CheckoutNewAddressForm;
